import { render, staticRenderFns } from "./StatsCardNew.vue?vue&type=template&id=5804b175&scoped=true"
import script from "./StatsCardNew.vue?vue&type=script&lang=js"
export * from "./StatsCardNew.vue?vue&type=script&lang=js"
import style0 from "./StatsCardNew.vue?vue&type=style&index=0&id=5804b175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804b175",
  null
  
)

export default component.exports